/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pin': {
    width: 16,
    height: 16,
    viewBox: '0 0 256 256',
    data: '<path pid="0" d="M253.4 131.9L123 1.6l-18.6 18.6L123 38.8 57.8 104 39.2 85.4 20.5 104l55.9 55.9-74.5 74.5L20.5 253 95 178.5l55.9 55.9 18.6-18.6-18.6-18.6 65.2-65.2 18.6 18.6 18.7-18.7zm-121.1 46.6l-55.9-55.9 65.2-65.2 55.9 55.9-65.2 65.2z"/>'
  }
})
